export const pl = {
  // Ogólne
  common: {
    loading: 'Ładowanie...',
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    add: 'Dodaj',
    close: 'Zamknij',
    back: 'Wstecz',
    previous: 'Poprzednia',
    next: 'Następna',
    search: 'Szukaj',
    filter: 'Filtr',
    all: 'Wszystkie',
    yes: 'Tak',
    no: 'Nie',
    notSpecified: 'Nie określono',
    confirm: 'Potwierdź',
    success: 'Sukces',
    error: 'Błąd',
    warning: 'Ostrzeżenie',
    info: 'Informacja',
    create: 'Utwórz',
    update: 'Aktualizuj',
    creating: 'Tworzenie...',
    updating: 'Aktualizowanie...',
    saving: 'Zapisywanie...',
    deleting: 'Usuwanie...',
    select: 'Wybierz...',
    selectClient: 'Wybierz klienta',
    selectBankAccount: 'Wybierz konto bankowe',
    noResults: 'Nie znaleziono wyników',
    adding: 'Dodawanie...',
    filters: 'Filtry',
    clear: 'Wyczyść',
    period: 'Okres',
    from: 'Od',
    to: 'Do',
    startDate: 'Data początkowa',
    endDate: 'Data końcowa',
    activeFilters: 'Aktywne filtry',
    collapse: 'Zwiń',
    expand: 'Rozwiń',
    selectPeriod: 'Wybierz okres',
    apply: 'Zastosuj',
    clearFilters: 'Wyczyść filtry',
    actions: 'Akcje',
    copy: 'Kopiuj',
    viewAll: 'Pokaż wszystko',
    bankName: 'Nazwa banku',
    accountNumber: 'Numer konta',
    currency: 'Waluta',
    balance: 'Saldo',
    bankAccounts: {
      swift: 'SWIFT',
      iban: 'IBAN'
    },
    editAccount: 'Edytuj konto bankowe',
    deleteAccountConfirm: 'Czy na pewno chcesz usunąć to konto bankowe?',
    comingSoon: 'Wkrótce'
  },

  // Nawigacja
  nav: {
    companies: 'Moje Firmy',
    invoices: 'Faktury',
    transactions: 'Transakcje',
    logout: 'Wyloguj się'
  },

  // Uwierzytelnianie
  auth: {
    login: 'Zaloguj się',
    register: 'Rejestracja',
    email: 'Email',
    password: 'Hasło',
    confirmPassword: 'Potwierdź hasło',
    loginButton: 'Zaloguj się',
    registerButton: 'Zarejestruj się',
    alreadyHaveAccount: 'Masz już konto?',
    noAccount: 'Nie masz konta?',
    switchToLogin: 'Zaloguj się',
    switchToRegister: 'Zarejestruj się',
    logoutConfirm: 'Czy na pewno chcesz się wylogować?',
    error: 'Błąd uwierzytelniania',
    registrationSuccess: 'Rejestracja przebiegła pomyślnie! Możesz się teraz zalogować.',
    passwordsDoNotMatch: 'Hasła nie są identyczne',
    emailRequired: 'Email jest wymagany',
    passwordRequired: 'Hasło jest wymagane',
    passwordMinLength: 'Hasło musi mieć co najmniej 6 znaków',
    activation: {
      title: 'Aktywacja konta',
      subtitle: 'Witamy',
      description: 'Ustaw hasło, aby zakończyć aktywację konta',
      activate: 'Aktywuj konto',
      activating: 'Aktywacja...',
      invalidToken: 'Nieprawidłowy link aktywacyjny',
      tokenExpired: 'Link aktywacyjny jest nieprawidłowy lub wygasł.',
      alreadyActivated: 'Konto jest już aktywowane',
      alreadyActivatedMessage: 'Twoje konto jest już aktywowane. Możesz się zalogować.'
    }
  },

  // Firmy
  companies: {
    title: 'Moje Firmy',
    createCompany: 'Utwórz firmę',
    addCompany: 'Dodaj firmę',
    companyName: 'Nazwa firmy',
    taxId: 'NIP/Registration Number',
    vatId: 'VAT ID',
    address: 'Adres',
    phone: 'Telefon',
    email: 'Email',
    website: 'Strona internetowa',
    logoPath: 'Logo firmy',
    currentLogo: 'Aktualne logo',
    country: 'Kraj',
    city: 'Miasto',
    companyAddress: 'Adres firmy',
    createDescription: 'Wypełnij informacje o swojej firmie',
    editDescription: 'Zaktualizuj informacje o firmie',
    logoSupport: 'Obsługiwane formaty: PNG, JPG, JPEG, SVG. Maksymalny rozmiar: 2MB',
    uploading: 'Przesyłanie...',
    upload: 'Prześlij',
    deleteLogo: 'Usuń logo',
    deleteLogoConfirm: 'Czy na pewno chcesz usunąć logo firmy?',
    deleteLogoError: 'Błąd podczas usuwania logo',
    saving: 'Zapisywanie...',
    deleting: 'Usuwanie...',
    create: 'Utwórz',
    save: 'Zapisz',
    cancel: 'Anuluj',
    companyNamePlaceholder: 'Nazwa Firmy Sp. z o.o.',
    taxIdPlaceholder: 'PL1234567890 lub 1234567890',
    vatIdPlaceholder: 'PL1234567890',
    phonePlaceholder: '+48 123 456 789',
    emailPlaceholder: 'info@firma.pl',
    websitePlaceholder: 'https://firma.pl',
    countryPlaceholder: 'Polska',
    cityPlaceholder: 'Warszawa',
    addressPlaceholder: 'ul. Przykładowa 1, lok. 123',
    chooseFile: 'Wybierz plik',
    noFileChosen: 'Nie wybrano pliku',
    details: 'Szczegóły',
    name: 'Nazwa',
    bankAccount: 'Konto bankowe',
    bankAccountName: 'Nazwa konta',
    bankAccountNamePlaceholder: 'Np.: Konto główne',
    accountNumber: 'Numer konta',
    bankName: 'Nazwa banku',
    bankAccounts: {
      title: 'Konta bankowe',
      addAccount: 'Dodaj konto',
      accountNumber: 'Numer konta',
      bankName: 'Nazwa banku',
      swift: 'SWIFT',
      iban: 'IBAN'
    },
    correspondentAccount: 'Konto korespondencyjne',
    correspondentBank: 'Bank korespondencyjny',
    bankAddress: 'Adres banku',
    currency: 'Waluta',
    balance: 'Saldo',
    editAccount: 'Edytuj konto bankowe',
    deleteAccountConfirm: 'Czy na pewno chcesz usunąć to konto bankowe?',
    // Zakładki
    tabs: {
      overview: 'Przegląd',
      accounts: 'Konta',
      invoices: 'Faktury',
      expenses: 'Koszty',
      contracts: 'Kontrakty',
      counterparties: 'Kontrahenci',
      bankTransactions: 'Transakcje bankowe',
      invoiceNumbering: 'Ustawienia numeracji',
      correctionInvoiceNumbering: 'Numeracja faktur korygujących',
      correctionInvoices: 'Faktury korygujące',
      users: 'Użytkownicy',
      settings: 'Ustawienia'
    },
    // Akcje
    edit: 'Edytuj',
    backToList: 'Powrót do listy',
    taxIdLabel: 'NIP',
    // Zakładki - zawartość
    overview: {
      title: 'Podstawowe informacje',
      statistics: 'Statystyki',
      name: 'Nazwa',
      taxId: 'NIP',
      address: 'Adres',
      phone: 'Telefon',
      email: 'Email',
      website: 'Strona internetowa',
      bankAccountsCount: 'Kont bankowych',
      invoicesCount: 'Faktur (30 dni)',
      counterpartiesCount: 'Kontrahentów',
      transactionsCount: 'Transakcji'
    },
    accounts: {
      title: 'Konta bankowe',
      addAccount: 'Dodaj konto',
      addFirstAccount: 'Dodaj pierwsze konto',
      noAccounts: 'Firma nie ma jeszcze kont bankowych',
      accountNumber: 'Konto',
      balance: 'Saldo',
      edit: 'Edytuj',
      updateError: 'Błąd podczas aktualizacji konta',
      deleteError: 'Błąd podczas usuwania konta'
    },
    invoices: {
      title: 'Faktury',
      createInvoice: 'Utwórz fakturę',
      createFirstInvoice: 'Utwórz pierwszą fakturę',
      searchPlaceholder: 'Szukaj faktur...',
      allStatuses: 'Wszystkie statusy',
      noInvoices: 'Firma nie ma jeszcze faktur',
      noInvoicesFound: 'Nie znaleziono faktur',
      allInvoicesLoaded: 'Wszystkie faktury zostały załadowane',
      totalInvoices: 'Wszystkie faktury',
      clearFilters: 'Wyczyść filtry',
      monthlyReportMonth: 'Miesiąc',
      invoiceListDateBasisLabel: 'Na liście miesiąc według',
      invoiceListDateBasisIssue: 'daty wystawienia (jak w kolumnie „Data”)',
      invoiceListDateBasisCreated: 'daty dodania do systemu',
      invoiceNumberVersusIssueDateHint:
        'Miesiąc w numerze faktury (np. …/02/…) może nie zgadzać się z datą wystawienia: numer jest z sekwencji, a datę dokumentu można zmienić osobno.',
      invoiceActions: 'Akcje',
      invoiceActionsHint:
        'Excel za wybrany miesiąc z wyborem: data wystawienia lub data sprzedaży. Dostępny jest też osobny raport VAT po dacie sprzedaży. Raporty obejmują wszystkie statusy oprócz szkicu i anulowanego. Przeliczanie VAT przeniesiono do zakładki integracji wFirma.',
      syncLatestMissingKsef: 'Synchronizuj KSeF dla ostatnich 20 bez numeru',
      syncLatestMissingKsefRunning: 'Synchronizacja KSeF…',
      syncLatestMissingKsefSummary: 'Zaktualizowano KSeF: {{updated}} z {{total}}. Błędy: {{failed}}.',
      downloadMonthlyReport: 'Pobierz Excel za miesiąc',
      downloadMonthlyVatReport: 'Pobierz VAT za miesiąc (data sprzedaży)',
      monthlyReportDateBasisPrompt: 'Filtr dla raportu',
      monthlyReportByIssueDate: 'Po dacie wystawienia za miesiąc',
      monthlyReportBySaleDate: 'Po dacie sprzedaży za miesiąc',
      monthlyReportGenerating: 'Generowanie raportu…',
      monthlyVatReportGenerating: 'Generowanie raportu VAT…',
      korygowanaModalTitle: 'Status Korygowana',
      korygowanaModalHint: 'Podaj nową kwotę i walutę dla faktury {{invoiceNumber}}.',
      korygowanaAmountLabel: 'Nowa kwota',
      korygowanaCurrencyLabel: 'Waluta',
      korygowanaSaveButton: 'Zapisz status',
      korygowanaAmountRequired: 'Podaj kwotę większą od 0',
      korygowanaSaveFailed: 'Nie udało się zapisać statusu Korygowana',
      recalcStoredTotals: 'Przelicz sumy w bazie za ten miesiąc',
      recalcStoredTotalsRefreshRates: 'Zaktualizuj kursy NBP przed przeliczeniem',
      recalcStoredTotalsRunning: 'Przeliczanie…',
      recalcStoredTotalsDone: 'Gotowe: zaktualizowano {{ok}} z {{total}}',
      recalcStoredTotalsSummary:
        'Przetworzono bez błędów: {{completed}} z {{total}}. Kwoty w bazie zmieniono dla {{changed}} faktur (pozostałe były zgodne z wyliczeniem).',
      recalcStoredTotalsNoInvoices: 'Brak faktur w tym miesiącu (data wystawienia) — nic do przeliczenia.',
      recalcStoredTotalsFailures: 'Błędów: {{n}}',
      recalcStoredTotalsError: 'Błąd przeliczania',
      loading: 'Ładowanie faktur...',
      client: 'Klient',
      date: 'Data',
      dueDate: 'Termin',
      details: 'Szczegóły',
    viewPdf: 'Podgląd PDF',
    downloadWfirmaPdf: 'PDF z wFirma',
    downloadWfirmaPdfLoading: 'Pobieranie z wFirma…',
    downloadPdf: 'Pobierz PDF',
      edit: 'Edytuj',
      viewDetails: 'Zobacz szczegóły',
      download: 'Pobierz',
      copy: 'Kopiuj',
      changeStatus: 'Zmień status',
      statuses: {
        DRAFT: 'Szkic',
        SENT: 'Wysłany',
        KORYGOWANA: 'Korygowana',
        PARTIALLY_PAID: 'Częściowo opłacony',
        PAID: 'Opłacony',
        OVERDUE: 'Przeterminowany',
        CANCELLED: 'Anulowany'
      },
      cannotEditNonDraft: 'Ta faktura nie może być edytowana, ponieważ jej status jest inny niż "Szkic". Można zmienić tylko status faktury.',
      cannotChangeToDraft: 'Nie można zmienić statusu faktury na "Szkic", jeśli została już wysłana.',
      paymentMethod: 'Metoda płatności',
      // Import faktur
      importInvoice: 'Import faktury',
    selectPdfFile: 'Wybierz plik PDF',
    parsedData: 'Rozpoznane dane',
      invoiceNumber: 'Numer faktury',
      issueDate: 'Data wystawienia',
      totalAmount: 'Kwota całkowita',
      buyerName: 'Nabywca',
      clientFound: 'Klient znaleziony',
      clientNotFound: 'Klient nie znaleziony',
      parsingFailed: 'Błąd rozpoznawania',
      importing: 'Importowanie...',
      import: 'Importuj',
      createCounterparty: 'Utwórz kontrahenta',
      createInvoiceFromParsed: 'Utwórz fakturę',
      counterpartyCreated: 'Kontrahent został utworzony pomyślnie',
      invoiceCreated: 'Faktura została utworzona pomyślnie',
      errorCreatingCounterparty: 'Błąd podczas tworzenia kontrahenta',
      errorCreatingInvoice: 'Błąd podczas tworzenia faktury',
      sendAllDrafts: 'Wyślij wszystkie szkice',
      sendAllDraftsConfirm: 'Wysłać wszystkie faktury ze statusem "Szkic" po kolei (według daty wystawienia)?',
      sendAllDraftsInProgress: 'Trwa wysyłanie...',
      sendAllDraftsProgress: 'Przetwarzanie faktur',
      sendAllDraftsDone: 'Gotowe',
      sendAllDraftsNoDrafts: 'Brak faktur ze statusem "Szkic"',
      sendAllDraftsFailed: 'Proces zatrzymany z powodu błędu'
    },
    expenses: {
      add: 'Dodaj koszt',
      edit: 'Edytuj koszt',
      deleteConfirm: 'Usunąć ten koszt?',
      search: 'Szukaj po numerze, nazwie, kontrahencie...',
      total: 'Łącznie',
      empty: 'Nie znaleziono kosztów',
      number: 'Numer',
      title: 'Nazwa',
      counterparty: 'Kontrahent',
      date: 'Data',
      amount: 'Kwota',
      status: 'Status',
      file: 'Plik',
      uploadFile: 'Prześlij',
      allCounterparties: 'Wszyscy kontrahenci',
      fileTypeError: 'Dozwolone są tylko PDF, PNG, JPG, JPEG',
      fileSizeError: 'Rozmiar pliku nie może przekraczać 10MB',
      netAmount: 'Kwota netto',
      taxAmount: 'Kwota podatku',
      grossAmount: 'Kwota brutto',
      category: 'Kategoria',
      notes: 'Notatki',
      issueDate: 'Data dokumentu',
      dueDate: 'Termin płatności',
      paymentDate: 'Data płatności',
      noCounterparties: 'Brak kontrahentów',
      statuses: {
        NEW: 'Nowy',
        APPROVED: 'Zatwierdzony',
        PAID: 'Opłacony',
        CANCELLED: 'Anulowany'
      }
    },
    contracts: {
      add: 'Dodaj kontrakt',
      edit: 'Edytuj kontrakt',
      deleteConfirm: 'Usunąć ten kontrakt?',
      search: 'Szukaj po numerze, nazwie, kontrahencie...',
      total: 'Łącznie',
      empty: 'Nie znaleziono kontraktów',
      number: 'Numer',
      title: 'Nazwa',
      counterparty: 'Kontrahent',
      period: 'Okres',
      status: 'Status',
      file: 'Plik',
      uploadFile: 'Prześlij',
      allCounterparties: 'Wszyscy kontrahenci',
      fileTypeError: 'Dozwolone są tylko PDF, PNG, JPG, JPEG',
      fileSizeError: 'Rozmiar pliku nie może przekraczać 10MB',
      valueAmount: 'Wartość kontraktu',
      notes: 'Notatki',
      startDate: 'Data rozpoczęcia',
      endDate: 'Data zakończenia',
      noCounterparties: 'Brak kontrahentów',
      statuses: {
        DRAFT: 'Szkic',
        ACTIVE: 'Aktywny',
        EXPIRED: 'Wygasły',
        TERMINATED: 'Rozwiązany'
      }
    },
    counterparties: {
      title: 'Kontrahenci',
      addCounterparty: 'Dodaj kontrahenta',
      addFirstCounterparty: 'Dodaj pierwszego kontrahenta',
      searchPlaceholder: 'Szukaj kontrahentów...',
      noCounterparties: 'Firma nie ma jeszcze kontrahentów',
      noCounterpartiesFound: 'Nie znaleziono kontrahentów',
      clearSearch: 'Wyczyść wyszukiwanie',
      loading: 'Ładowanie kontrahentów...',
      taxId: 'NIP',
      vatId: 'VAT',
      contact: 'Kontakt',
      email: 'Email',
      phone: 'Telefon',
      address: 'Adres',
      city: 'Miasto',
      comment: 'Komentarz',
      edit: 'Edytuj',
      delete: 'Usuń',
      deleteConfirm: 'Czy na pewno chcesz usunąć kontrahenta',
      syncStatus: {
        synced: 'Zsynchronizowany',
        notSynced: 'Nie zsynchronizowany',
        noSync: 'Brak synchronizacji'
      },
      syncConfirmTitle: 'Synchronizacja z wFirma',
      syncConfirm: 'Utworzyć kontrahenta "{name}" w wFirma?',
      syncInProgress: 'Synchronizacja...',
      syncInProgressMessage: 'Proszę czekać, trwa synchronizacja kontrahenta z wFirma',
      syncSuccessTitle: 'Synchronizacja zakończona sukcesem',
      syncSuccess: 'Kontrahent został pomyślnie zsynchronizowany z wFirma',
      syncErrorTitle: 'Błąd synchronizacji',
      syncError: 'Wystąpił błąd podczas synchronizacji kontrahenta z wFirma',
      syncClickHint: 'Kliknij, aby zsynchronizować z wFirma',
      unsyncAll: 'Odłącz od wFirma',
      unsyncAllHint: 'Zresetuj powiązanie wFirma dla wszystkich kontrahentów (do ponownego połączenia z nowym kontem wFirma)',
      unsyncAllConfirm: 'Zresetować powiązanie wFirma dla wszystkich kontrahentów? Następnie można ponownie zsynchronizować z nowym kontem wFirma.',
      unsyncAllSuccess: 'Powiązanie zresetowane',
      syncAll: 'Synchronizuj do wFirma',
      syncAllHint: 'Dodaj wszystkich kontrahentów do wFirma',
      syncAllSuccess: 'Wszyscy kontrahenci zsynchronizowani',
      linkWfirma: 'Powiąż z wFirma',
      wfirmaLinkTitle: 'Szukaj w wFirma i powiąż',
      wfirmaLinkName: 'Nazwa',
      wfirmaLinkSearch: 'Szukaj',
      wfirmaLinkSearching: 'Szukanie...',
      wfirmaLinkNoResults: 'Brak wyników. Doprecyzuj nazwę, NIP lub VAT.',
      wfirmaLinkSearchError: 'Błąd wyszukiwania w wFirma',
      wfirmaLinkColName: 'Nazwa',
      wfirmaLinkColCountry: 'Kraj',
      wfirmaLinkColTaxType: 'Typ ID',
      wfirmaLinkConfirm: 'Powiąż',
      wfirmaLinkLinking: 'Powiązywanie...',
      wfirmaLinkError: 'Nie udało się powiązać'
    },
    users: {
      title: 'Użytkownicy firmy',
      addUser: 'Dodaj użytkownika',
      email: 'Email',
      role: 'Rola',
      noUsers: 'Nie znaleziono użytkowników',
      noUsersFound: 'Nie znaleziono użytkowników',
      confirmRemove: 'Czy na pewno chcesz usunąć tego użytkownika?',
      searchUser: 'Email użytkownika',
      searchPlaceholder: 'Wpisz email...',
      selectedUser: 'Wybrany',
      emailHint: 'Możesz dodać istniejącego użytkownika lub utworzyć nowego',
      status: 'Status',
      activated: 'Aktywowany',
      notActivated: 'Nieaktywowany',
      linkCopied: 'Link skopiowany do schowka',
      cannotRemoveSelf: 'Nie można usunąć siebie',
      accessDenied: 'Dostęp ograniczony',
      onlyAdminAccess: 'Tylko administrator firmy ma dostęp do zarządzania użytkownikami.',
      roles: {
        ADMIN: 'Administrator',
        EMPLOYEE: 'Pracownik',
        VIEWER: 'Przeglądanie'
      }
    },
    import: {
      import: 'Import',
      importing: 'Importowanie...',
      downloadTemplate: 'Pobierz szablon',
      selectFile: 'Wybierz plik',
      selectedFile: 'Wybrany plik',
      imported: 'Zaimportowano',
      errors: 'Błędy',
      selectSource: 'Wybierz źródło importu',
      fromFile: 'Import z pliku',
      fromFileDescription: 'Plik CSV lub Excel',
      fromWFirma: 'Import z wFirma',
      fromWFirmaDescription: 'Import wszystkich kontrahentów z wFirma',
      wfirmaNotConfigured: 'Najpierw skonfiguruj integrację wFirma w ustawieniach firmy',
      wfirmaImportDescription: 'Importuje wszystkich kontrahentów z wFirma. Istniejący kontrahenci zostaną zaktualizowani.',
      wfirmaMatchOnlyHint:
        'Tylko dopasowanie: ustawia ID wFirma u istniejących kontrahentów bez tworzenia nowych. Niejednoznaczne przypadki są pomijane.',
      matchOnlyFromWfirma: 'Tylko dopasuj',
      matchOnlyRunning: 'Dopasowywanie...',
      matchOnlyLinked: 'Powiązano',
      matchOnlySkippedAmbiguous: 'Pominięto (wiele w wFirma)',
      matchOnlySkippedNoMatch: 'Brak dopasowania',
      created: 'Utworzono',
      updated: 'Zaktualizowano',
      skipped: 'Pominięto',
      counterparties: {
        title: 'Import kontrahentów'
      },
      bankAccounts: {
        title: 'Import kont bankowych'
      }
    },
    transactions: {
      title: 'Transakcje',
      addTransaction: 'Dodaj transakcję',
      addFirstTransaction: 'Dodaj pierwszą transakcję',
      noTransactions: 'Firma nie ma jeszcze transakcji'
    },
    bankTransactions: {
      title: 'Transakcje bankowe',
      importCsv: 'Import CSV',
      autoMatch: 'Automatyczne dopasowanie',
      matching: 'Dopasowywanie...',
      loading: 'Ładowanie transakcji...',
      totalTransactions: 'Wszystkie transakcje',
      matchedTransactions: 'Dopasowane',
      unmatchedTransactions: 'Niedopasowane',
      matchingRate: 'Procent dopasowania',
      unmatchConfirm: 'Czy na pewno chcesz cofnąć dopasowanie transakcji?',
      deleteConfirm: 'Czy na pewno chcesz usunąć transakcję?',
      // Tabela
      table: {
        date: 'Data',
        description: 'Opis',
        type: 'Typ',
        amount: 'Kwota',
        status: 'Status',
        actions: 'Akcje',
        noTransactions: 'Nie znaleziono transakcji'
      },
      // Statusy
      status: {
        matched: 'Dopasowana',
        unmatched: 'Niedopasowana'
      },
      // Typy transakcji
      types: {
        INCOME: 'Przychód',
        EXPENSE: 'Wydatek'
      },
      // Akcje
      actions: {
        match: 'Dopasuj',
        unmatch: 'Cofnij dopasowanie',
        delete: 'Usuń'
      },
      // Filtry
      allAccounts: 'Wszystkie konta',
      transactionType: 'Typ transakcji',
      allTypes: 'Wszystkie typy',
      income: 'Przychody',
      expense: 'Wydatki',
      category: 'Kategoria',
      allCategories: 'Wszystkie kategorie',
      searchPlaceholder: 'Szukaj po opisie, kontrahencie...',
      type: 'Typ',
      // Paginacja
      pagination: {
        showing: 'Wyświetlono {{count}} z {{total}} transakcji'
      }
    }
  },

  // Faktury
  invoices: {
    title: 'Faktury',
    createInvoice: 'Utwórz fakturę',
    invoiceNumber: 'Numer faktury',
    wfirmaInvoiceNumber: 'Numer faktury w wFirma',
    ksefNumber: 'Numer KSeF',
    clientId: 'Klient',
    issueDate: 'Data wystawienia',
    dueDate: 'Termin płatności',
    saleDate: 'Data sprzedaży',
    placeOfIssue: 'Miejsce wystawienia',
    invoiceType: 'Typ faktury',
    exchangeRate: 'Kurs walutowy',
    exchangeRateTable: 'Tabela kursów',
    exchangeRateDate: 'Data kursu',
    reverseCharge: 'Odwrotne obciążenie VAT',
    status: 'Status',
    paymentMethod: 'Metoda płatności',
    notes: 'Uwagi',
    notesPlaceholder: 'Dodatkowe informacje...',
    internalComment: 'Komentarz',
    internalCommentPlaceholder: 'Komentarz wewnętrzny (nie wyświetla się na fakturze)...',
    internalCommentHint: 'Ten komentarz jest widoczny tylko dla Ciebie i nie będzie wyświetlany w PDF faktury',
    basicInfo: 'Podstawowe informacje',
    seller: 'Sprzedawca',
    buyer: 'Nabywca',
    additionalInfo: 'Dodatkowe informacje',
    selectFile: 'Wybierz plik',
    parseFile: 'Przetwórz plik',
    chooseFile: 'Wybierz plik',
    noFileChosen: 'Nie wybrano pliku',
    duplicateInvoice: 'Faktura już istnieje',
    duplicateInvoiceMessage: 'Faktura o tym numerze już istnieje. Co chcesz zrobić?',
    saveWithNewNumber: 'Zapisz z nowym numerem',
    cancelImport: 'Anuluj import',
    editInvoiceNumber: 'Edytuj numer faktury',
    items: 'Pozycje',
    descriptionPlaceholder: 'Opis usługi/produktu',
    addItem: 'Dodaj pozycję',
    description: 'Opis',
    quantity: 'Ilość',
    unitPrice: 'Cena jednostkowa',
    unitOfMeasure: 'Jednostka miary',
    unitOfMeasures: {
      PIECE: 'szt.',
      HOUR: 'godz.',
      DAY: 'dzień',
      WEEK: 'tydzień',
      MONTH: 'miesiąc',
      KG: 'kg',
      TON: 't',
      METER: 'm',
      SQUARE_METER: 'm²',
      CUBIC_METER: 'm³',
      LITER: 'l',
      SET: 'zestaw'
    },
    taxRate: 'VAT %',
    total: 'Suma',
    subtotal: 'Suma częściowa',
    taxAmount: 'Kwota podatku',
    grandTotal: 'RAZEM',
    editInvoice: 'Edytuj fakturę',
    edit: 'Edytuj',
    viewDetails: 'Zobacz szczegóły',
    deleteInvoiceConfirm: 'Czy na pewno chcesz usunąć tę fakturę?',
    deleteInvoiceOnlySample: 'Usuwanie jest dozwolone tylko dla faktur ze statusem Szkic.',
    deleteInvoiceOnlyNotSentToWfirma: 'Nie można usunąć faktury, która została już wysłana do wFirma.',
    viewPdf: 'Podgląd PDF',
    downloadWfirmaPdf: 'PDF z wFirma',
    downloadWfirmaPdfLoading: 'Pobieranie z wFirma…',
    pdfLanguage: 'Język faktury',
    downloadPdf: 'Pobierz PDF',
    download: 'Pobierz',
    copy: 'Kopiuj',
    copyInvoice: 'Kopiuj Fakturę',
    create: 'Utwórz',
    createError: 'Błąd tworzenia faktury',
    importError: 'Błąd importu faktury',
    pdfViewer: {
      title: 'Podgląd faktury',
      language: 'Język',
      download: 'Pobierz PDF',
      downloading: 'Pobieranie...',
      close: 'Zamknij',
      loading: 'Ładowanie PDF...',
      notLoaded: 'PDF nie został załadowany',
      loadPdf: 'Załaduj PDF'
    },
    currency: 'Waluta',
    currencies: {
      USD: 'USD - Dolar amerykański',
      EUR: 'EUR - Euro',
      GBP: 'GBP - Funt brytyjski',
      CNY: 'CNY - Yuan chiński',
      CAD: 'CAD - Dolar kanadyjski',
      PLN: 'PLN - Złoty polski'
    },
    statuses: {
      DRAFT: 'Szkic',
      SENT: 'Wysłany',
      KORYGOWANA: 'Korygowana',
      PARTIALLY_PAID: 'Częściowo opłacony',
      PAID: 'Opłacony',
      OVERDUE: 'Przeterminowany',
      CANCELLED: 'Anulowany'
    },
    wfirma: {
      sendConfirmTitle: 'Wysyłanie faktury do wFirma',
      sendConfirm: 'Wysłać fakturę "{number}" do wFirma?',
      alreadySyncedPrompt: 'Ta faktura została już wysłana do wFirma. Wysłać ją jako nową fakturę?',
      sendExistingLink: 'Wyślij bez tworzenia nowej',
      sendAsNew: 'Wyślij jako nową',
      syncing: 'Wysyłanie do wFirma...',
      syncingMessage: 'Proszę czekać, trwa wysyłanie faktury do wFirma',
      sendSuccessTitle: 'Faktura wysłana',
      sendSuccess: 'Faktura została pomyślnie wysłana do wFirma',
      sendErrorTitle: 'Błąd wysyłania',
      sendError: 'Wystąpił błąd podczas wysyłania faktury do wFirma',
      syncCounterpartyRequired: 'Wymagana synchronizacja kontrahenta',
      syncCounterpartyMessage: 'Kontrahent "{name}" nie jest zsynchronizowany z wFirma. Musisz zsynchronizować kontrahenta przed wysłaniem faktury.',
      syncCounterparty: 'Synchronizuj kontrahenta',
      selectVatCodes: 'Wybierz kody VAT',
      selectVatCodesMessage: 'Nie znaleziono kodów VAT dla niektórych pozycji. Proszę wybrać odpowiednie kody:'
    },
    types: {
      STANDARD: 'Faktura VAT',
      PROFORMA: 'Faktura proforma',
      STANDARD_NO_VAT: 'Faktura (bez VAT)',
      PROFORMA_NO_VAT: 'Pro forma (bez VAT)'
    },
    paymentMethods: {
      BANK_TRANSFER: 'Przelew bankowy',
      CASH: 'Gotówka'
    },
    units: {
      PIECE: 'szt.',
      HOUR: 'godz.',
      DAY: 'dzień',
      WEEK: 'tydzień',
      MONTH: 'miesiąc',
      KG: 'kg',
      TON: 't',
      METER: 'm',
      SQUARE_METER: 'm²',
      CUBIC_METER: 'm³',
      LITER: 'l',
      SET: 'kompl.'
    },
    // Formularz wieloetapowy
    multiStep: {
      basicInfo: 'Podstawowe informacje',
      items: 'Pozycje faktury',
      currency: 'Kurs walutowy',
      review: 'Sprawdzenie',
      next: 'Dalej',
      back: 'Wstecz',
      addItem: 'Dodaj pozycję'
    },
    // Import
    import: {
      title: 'Import faktury',
      uploadTitle: 'Przesyłanie pliku faktury',
      dragAndDrop: 'Przeciągnij i upuść plik PDF tutaj lub kliknij, aby wybrać',
      selectFile: 'Wybierz plik PDF',
      uploading: 'Przesyłanie...',
      parsing: 'Przetwarzanie...',
      fileSelected: 'Plik wybrany',
      createCounterparty: 'Tworzenie kontrahenta',
      createBankAccount: 'Tworzenie konta bankowego',
      createInvoice: 'Tworzenie faktury',
      counterpartyInfo: 'Informacje o kontrahencie',
      bankAccountInfo: 'Informacje o koncie bankowym',
      invoiceInfo: 'Informacje o fakturze',
      invoiceItems: 'Pozycje faktury',
      editableItems: 'Możesz edytować pozycje faktury poniżej:',
      calculatedTotal: 'Obliczona suma',
      skipStep: 'Pomiń ten krok',
      useExisting: 'Użyj istniejącego',
      prefilledData: 'Dane wstępnie wypełnione z przesłanej faktury. Możesz edytować dowolne pole przed utworzeniem.',
      steps: {
        upload: 'Przesyłanie pliku',
        counterparty: 'Kontrahent',
        bankAccount: 'Konto bankowe',
        invoice: 'Faktura'
      }
    },
    // Kursy walutowe
    exchangeRates: {
      title: 'Wybór kursu walutowego',
      showFields: 'Pokaż pola kursu walutowego',
      description: 'Aby obliczyć VAT w złotych polskich, musisz wybrać kurs walutowy dla',
      forDate: 'daty poprzedzającej datę wystawienia faktury',
      autoSelected: 'Automatycznie wybrano kurs dla najbliższej dostępnej daty przed datą wystawienia. Możesz zmienić wybór poniżej.',
      selectRate: 'Wybierz kurs walutowy',
      rateInfo: 'Informacje o kursie',
      date: 'Data',
      rate: 'Kurs',
      table: 'Tabela',
      vatInPln: 'VAT w PLN',
      willBeRequired: 'Na następnym kroku konieczne będzie wybranie kursu walutowego do obliczenia VAT w PLN.',
      selectRateRequired: 'Proszę wybrać kurs walutowy',
      loading: 'Ładowanie kursów walutowych...',
      noRates: 'Nie znaleziono kursów walutowych dla wybranej daty. Proszę dodać kurs walutowy ręcznie.',
      pleaseSelect: 'Proszę wybrać kurs walutowy z listy poniżej.',
      loadRates: 'Załaduj aktualne kursy walut',
      loadError: 'Nie udało się załadować kursów walutowych. Proszę spróbować później.'
    },
    // Przegląd
    reviewStep: {
      title: 'Przegląd danych',
      invoiceNumber: 'Numer faktury',
      client: 'Klient',
      invoiceType: 'Typ faktury',
      currency: 'Waluta',
      issueDate: 'Data wystawienia',
      dueDays: 'Termin płatności',
      days: 'dni',
      exchangeRateInfo: 'Kurs walutowy',
      rateDate: 'Data kursu',
      positions: 'Pozycje',
      notSelected: 'Nie wybrano'
    },
    // Błędy walidacji
    validation: {
      required: 'Wymagane',
      invoiceNumberRequired: 'Numer faktury jest wymagany',
      clientRequired: 'Klient jest wymagany',
      invoiceTypeRequired: 'Typ faktury jest wymagany',
      currencyRequired: 'Waluta jest wymagana',
      issueDateRequired: 'Data wystawienia jest wymagana',
      dueDaysRequired: 'Termin płatności jest wymagany',
      dueDaysMin: 'Termin płatności musi być większy niż 0 dni',
      bankAccountRequired: 'Konto bankowe jest wymagane',
      accountNumberRequired: 'Numer konta jest wymagany',
      bankAccountNameRequired: 'Nazwa konta jest wymagana',
      bankNameRequired: 'Nazwa banku jest wymagana',
      balanceNonNegative: 'Saldo nie może być ujemne',
      placeOfIssueRequired: 'Miejsce wystawienia jest wymagane',
      descriptionRequired: 'Opis jest wymagany',
      quantityRequired: 'Ilość jest wymagana',
      quantityMin: 'Ilość musi być większa niż 0',
      unitPriceRequired: 'Cena jednostkowa jest wymagana',
      unitPriceMin: 'Cena jednostkowa musi być większa niż 0',
      companyNameRequired: 'Nazwa firmy jest wymagana',
      taxIdRequired: 'NIP/Registration Number jest wymagany',
      taxIdMinLength: 'Minimum 3 znaki',
      taxIdMaxLength: 'Maksimum 20 znaków',
      vatIdMaxLength: 'Maksimum 20 znaków',
      emailInvalid: 'Wprowadź prawidłowy email',
      cityRequired: 'Miasto jest wymagane',
      fileValidationError: 'Błąd walidacji pliku',
      logoUploadError: 'Błąd przesyłania logo',
      fillRequiredFields: 'Proszę wypełnić wszystkie wymagane pola'
    }
  },

  // Kontrahenci
  counterparties: {
    title: 'Kontrahenci',
    createCounterparty: 'Utwórz kontrahenta',
    counterpartyName: 'Nazwa kontrahenta',
    contactPerson: 'Osoba kontaktowa',
    addCounterparty: 'Dodaj kontrahenta'
  },

  // Transakcje
  transactions: {
    title: 'Transakcje bankowe',
    noTransactionsFound: 'Nie znaleziono transakcji',
    createTransaction: 'Dodaj transakcję',
    import: {
      title: 'Import transakcji',
      bankAccount: 'Konto bankowe',
      selectFile: 'Wybierz plik',
      selectFiles: 'Wybierz pliki',
      selectedFiles: 'Wybrane pliki',
      singleFile: 'Pojedynczy plik',
      multipleFiles: 'Import wielokrotny',
      import: 'Importuj',
      importing: 'Importowanie...',
      supportedFormats: 'Obsługiwane formaty: CSV, TXT, PDF'
    },
    table: {
      date: 'Data',
      description: 'Opis',
      counterparty: 'Kontrahent',
      amount: 'Kwota',
      type: 'Typ',
      currency: 'Waluta',
      status: 'Status',
      actions: 'Akcje'
    },
    statuses: {
      matched: 'Dopasowana',
      unmatched: 'Niedopasowana',
      income: 'Przychód',
      expense: 'Wydatek'
    },
    actions: {
      match: 'Dopasuj',
      unmatch: 'Anuluj dopasowanie'
    },
    matching: {
      title: 'Dopasowanie transakcji',
      transactionInfo: 'Informacje o transakcji',
      selectInvoice: 'Wybierz fakturę',
      selectInvoicePlaceholder: 'Wybierz fakturę do dopasowania',
      match: 'Dopasuj',
      matching: 'Dopasowywanie...'
    }
  },

  // Języki
  languages: {
    title: 'Język interfejsu',
    polishOnly: 'Polski',
    polishEnglish: 'Polski-English',
    english: 'English'
  },

  // Waluty
  currencies: {
    USD: 'USD - Dolar amerykański',
    EUR: 'EUR - Euro',
    CNY: 'CNY - Juan chiński',
    GBP: 'GBP - Funt brytyjski',
    CAD: 'CAD - Dolar kanadyjski',
    PLN: 'PLN - Złoty polski'
  },

  // Kontrahenci
  counterparty: {
    addTitle: 'Dodaj kontrahenta',
    editTitle: 'Edytuj kontrahenta',
    name: 'Nazwa',
    nameRequired: 'Nazwa jest wymagana',
    namePlaceholder: 'Sp. z o.o. Kontrahent',
    taxId: 'NIP',
    taxIdPlaceholder: '123456789012',
    vatId: 'VAT',
    vatIdPlaceholder: 'VAT123456789',
    address: 'Adres',
    addressPlaceholder: 'Warszawa, ul. Przykładowa, 1',
    contactPerson: 'Osoba kontaktowa',
    contactPersonPlaceholder: 'Jan Kowalski',
    email: 'Email',
    emailPlaceholder: 'kontakt@firma.pl',
    phone: 'Telefon',
    phonePlaceholder: '+48-123-456-789',
    country: 'Kraj',
    countryPlaceholder: 'Polska',
    city: 'Miasto',
    cityPlaceholder: 'Warszawa',
    comment: 'Komentarz',
    commentPlaceholder: 'Wpisz komentarz...',
    createError: 'Błąd tworzenia kontrahenta',
    wfirmaSync: 'Synchronizacja z wFirma',
    wfirmaId: 'ID w wFirma',
    removeSync: 'Usuń synchronizację',
    unsyncConfirm: 'Czy na pewno chcesz usunąć synchronizację z wFirma? Możesz później ponownie zsynchronizować kontrahenta.',
    wfirmaSyncHint: 'Po usunięciu synchronizacji możesz ponownie zsynchronizować kontrahenta',
    details: {
      title: 'Informacje o kontrahencie',
      notFound: 'Kontrahent nie znaleziony',
      invoicesTitle: 'Faktury kontrahenta',
      loadingInvoices: 'Ładowanie faktur...',
      noInvoices: 'Nie znaleziono faktur'
    }
  },

  // Faktury korygujące
  correctionInvoices: {
    title: 'Faktury korygujące',
    manageCorrections: 'Zarządzanie korektami',
    description: 'Przejdź na stronę zarządzania fakturami korygującymi, aby tworzyć i przeglądać korekty.',
    createCorrection: 'Utwórz korektę',
    viewCorrections: 'Zobacz korekty',
    noCorrectionsFound: 'Nie znaleziono faktur korygujących',
    tryAgain: 'Spróbuj ponownie',
    statuses: {
      DRAFT: 'Szkic',
      SENT: 'Wysłany',
      ACCEPTED: 'Przyjęty',
      REJECTED: 'Odrzucony'
    },
    types: {
      CORRECTION: 'Korekta',
      CANCELLATION: 'Anulowanie',
      REPLACEMENT: 'Zastąpienie'
    },
    tableHeaders: {
      number: 'Numer',
      date: 'Data',
      type: 'Typ',
      status: 'Status',
      difference: 'Różnica',
      reason: 'Powód',
      actions: 'Akcje'
    },
    statusOptions: {
      send: 'Wyślij',
      accept: 'Przyjmij',
      reject: 'Odrzuć'
    },
    delete: 'Usuń',
    deleteConfirm: 'Czy na pewno chcesz usunąć tę fakturę korygującą?',
    pagination: {
      showing: 'Pokazano',
      of: 'z',
      records: 'rekordów'
    },
    errors: {
      updateStatus: 'Błąd podczas aktualizacji statusu',
      deleteError: 'Błąd podczas usuwania faktury korygującej',
      downloadError: 'Błąd podczas pobierania PDF'
    },
    modal: {
      title: 'Utwórz fakturę korygującą',
      originalInvoice: 'Oryginalna faktura',
      selectOriginalInvoice: 'Wybierz oryginalną fakturę',
      searchInvoice: 'Szukaj po numerze faktury...',
      noInvoicesFound: 'Nie znaleziono faktur',
      correctionNumber: 'Numer korekty',
      correctionDate: 'Data korekty',
      reason: 'Powód korekty',
      reasonPlaceholder: 'Opisz powód korekty',
      correctionType: 'Typ korekty',
      items: 'Pozycje',
      addItem: 'Dodaj pozycję',
      removeItem: 'Usuń pozycję',
      description: 'Opis',
      unitOfMeasure: 'Jednostka miary',
      originalQuantity: 'Oryginalna ilość',
      originalUnitPrice: 'Oryginalna cena jednostkowa',
      originalTotalPrice: 'Oryginalna cena całkowita',
      originalTaxRate: 'Oryginalna stawka podatku',
      originalTaxAmount: 'Oryginalna kwota podatku',
      correctedQuantity: 'Poprawiona ilość',
      correctedUnitPrice: 'Poprawiona cena jednostkowa',
      correctedTotalPrice: 'Poprawiona cena całkowita',
      correctedTaxRate: 'Poprawiona stawka podatku',
      correctedTaxAmount: 'Poprawiona kwota podatku',
      save: 'Zapisz',
      cancel: 'Anuluj',
      saving: 'Zapisywanie...',
      loading: 'Ładowanie...',
      error: 'Błąd podczas tworzenia faktury korygującej',
      loadError: 'Błąd podczas ładowania oryginalnej faktury',
      createError: 'Błąd podczas tworzenia faktury korygującej',
      // Komunikaty walidacji
      required: 'jest wymagane',
      requiredF: 'jest wymagane',
      // Nagłówki kolumn tabeli pozycji (krótkie wersje dla UI)
      originalPrice: 'Org. cena',
      correctedPrice: 'Popr. cena',
      originalAmount: 'Org. kwota',
      correctedAmount: 'Popr. kwota',
      difference: 'Różnica',
      remove: 'Usuń'
    }
  },
  invoiceNumbering: {
    title: 'Ustawienia numeracji faktur',
    template: 'Szablon numeracji',
    templateDescription: {
      NN_MM_YYYY: 'Numer kolejny/miesiąc/rok (np.: 01/09/2025)',
      NN_YYYY: 'Numer kolejny/rok (np.: 01/2025)',
      NN_MM_YYYY_ID: 'Numer kolejny/miesiąc/rok/sufiks (np.: 01/09/2025/ABC)'
    },
    suffix: 'Sufiks',
    suffixPlaceholder: 'Wprowadź sufik (np.: ABC, 2025)',
    currentSequence: 'Aktualny numer kolejny',
    nextNumber: 'Następny numer faktury będzie: {number}',
    preview: 'Podgląd',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    loadError: 'Błąd ładowania ustawień',
    saveError: 'Błąd zapisywania ustawień',
    generateNew: 'Wygeneruj nowy numer',
    generateNewTooltip: 'Wygeneruj nowy numer'
  },
  correctionInvoiceNumbering: {
    title: 'Ustawienia numeracji faktur korygujących',
    template: 'Szablon numeracji',
    templateDescription: {
      NN_MM_YYYY: 'Numer kolejny/miesiąc/rok (np.: 01/09/2025)',
      NN_YYYY: 'Numer kolejny/rok (np.: 01/2025)',
      NN_MM_YYYY_ID: 'Numer kolejny/miesiąc/rok/sufiks (np.: 01/09/2025/KOR)'
    },
    suffix: 'Sufiks',
    suffixPlaceholder: 'Wprowadź sufik (np.: KOR, ABC)',
    currentSequence: 'Aktualny numer kolejny',
    nextNumber: 'Następny numer faktury korygującej będzie: {number}',
    preview: 'Podgląd',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    loadError: 'Błąd ładowania ustawień',
    saveError: 'Błąd zapisywania ustawień',
    generateNew: 'Wygeneruj nowy numer',
    generateNewTooltip: 'Wygeneruj nowy numer'
  },
  settings: {
    sections: {
      invoiceNumbering: 'Numeracja faktur',
      correctionInvoiceNumbering: 'Numeracja faktur korygujących',
      integrations: 'Integracje'
    }
  },
  integrations: {
    wfirma: {
      title: 'Integracja wFirma',
      description: 'Skonfiguruj połączenie z wFirma w celu synchronizacji kontrahentów',
      credentialsSection: 'Dane połączenia i klucze API',
      accountsSection: 'Konta i powiązania wFirma',
      recalcStoredTotalsHint: 'Przeliczenie odbywa się wg daty wystawienia faktur dla wybranego miesiąca.',
      companyId: 'ID firmy w wFirma',
      companyIdHint: 'ID Twojej firmy w systemie wFirma',
      accessKey: 'Access Key',
      accessKeyPlaceholder: 'Wprowadź Access Key',
      secretKey: 'Secret Key',
      secretKeyPlaceholder: 'Wprowadź Secret Key',
      secretKeyHint: 'Wyświetlane tylko raz przy tworzeniu',
      appKey: 'App Key',
      appKeyPlaceholder: 'Wprowadź App Key',
      appKeyHint: 'Wydawane przez wFirma.pl indywidualnie dla każdej aplikacji',
      loadError: 'Błąd ładowania konfiguracji',
      saveError: 'Błąd zapisywania konfiguracji',
      saveSuccess: 'Konfiguracja zapisana pomyślnie',
      deleteError: 'Błąd usuwania konfiguracji',
      deleteSuccess: 'Konfiguracja usunięta',
      deleteConfirm: 'Czy na pewno chcesz usunąć konfigurację wFirma?',
      fillAllFields: 'Proszę wypełnić wszystkie pola',
      useWfirmaInvoiceNumber: 'Używaj numeru faktury z wFirma',
      useWfirmaInvoiceNumberHint:
        'Do czasu wysyłki faktura dostaje tymczasowy numer z prefiksem W (np. W19/10/2026). Po udanej wysyłce jest zastępowany numerem z wFirma, o ile nie jest zajęty przez inną fakturę.',
      pullMetadataTitle: 'Pobierz z wFirma: numery KSeF i numery faktur',
      pullMetadataHint:
        'Dla faktur powiązanych z wFirma pobiera aktualne dane po ID w wFirma. Numer KSeF często pojawia się z opóźnieniem — uruchamiaj okresowo.',
      pullMetadataKsef: 'Aktualizuj numery KSeF',
      pullMetadataNumbers: 'Nadpisz numery faktur z wFirma',
      pullMetadataNeedFlags: 'Zaznacz co najmniej jedno: KSeF lub numer faktury z wFirma',
      pullMetadataButton: 'Pobierz z wFirma',
      pullMetadataUpdated: 'Zaktualizowano',
      pullMetadataSkipped: 'Bez zmian',
      syncProgressSent: 'Wysłano',
      syncProgressCurrent: 'Teraz',
      syncProgressPreparing: 'Przygotowanie…',
      bulkInvoicesTitle: 'Wysyłanie faktur do wFirma za okres',
      bulkInvoicesHint:
        'Wybierz zakres dat. Bez „Ponowna wysyłka” pomijane są już zsynchronizowane faktury. Po włączeniu opcji stare powiązania są czyszczone i faktury tworzone są ponownie w wFirma.',
      periodFrom: 'Od',
      periodTo: 'Do',
      dateField: 'Okres według',
      dateFieldIssue: 'Data wystawienia',
      dateFieldSale: 'Data sprzedaży',
      forceResync: 'Ponowna wysyłka (wyczyść stare powiązanie z wFirma)',
      sendPeriod: 'Wyślij do wFirma',
      periodDatesRequired: 'Podaj datę początku i końca okresu',
      resultTotal: 'W wyborze',
      resultSuccess: 'Wysłano',
      resultSkipped: 'Pominięto (już w wFirma)',
      resultFailed: 'Błędów',
      errorList: 'Lista błędów',
      resetInvoicesTitle: 'Reset wysłanych faktur do szkiców',
      resetInvoicesHint:
        'Dla faktur ze statusem Wysłana w wybranym okresie ustawiony zostanie status Szkic, a identyfikator wFirma zostanie wyczyszczony. Przydaje się to przed ręczną wysyłką faktur pojedynczo.',
      resetToDraftButton: 'Resetuj do szkiców',
      resetToDraftResult: 'Przeniesiono do szkiców',
      resetSkippedNotSent: 'Pominięto (status nie został wybrany)',
      resetStatusesLabel: 'Które statusy resetować',
      resetStatusesRequired: 'Wybierz co najmniej jeden status',
      resetConfirm: 'Przenieść wszystkie wysłane faktury z tego okresu z powrotem do szkiców i wyczyścić ich wFirma ID?',
      vatCodesTitle: 'Weryfikacja kodów VAT wFirma',
      vatCodesHint: 'Odświeża kody VAT z bieżącego konta wFirma i pokazuje podstawową kontrolę kluczowych stawek/kodów.',
      vatCodesRefreshButton: 'Odśwież i sprawdź kody VAT',
      vatCodesTotal: 'Łącznie kodów VAT',
      vatCodesListTitle: 'Lista kodów VAT z wFirma',
      accounts: {
        title: 'Konta wFirma',
        description: 'Synchronizuj i połącz konta firmy z kontami w wFirma',
        sync: 'Synchronizuj konta',
        syncSuccess: 'Konta zostały pomyślnie zsynchronizowane',
        syncError: 'Błąd synchronizacji kont',
        autoMap: 'Automatycznie połącz',
        autoMapSuccess: 'Automatycznie połączono kont',
        autoMapError: 'Błąd automatycznego łączenia kont',
        wfirmaAccounts: 'Konta w wFirma',
        noWFirmaAccounts: 'Brak zsynchronizowanych kont. Kliknij "Synchronizuj konta", aby załadować.',
        ourAccounts: 'Nasze konta',
        noOurAccounts: 'Brak kont firmy',
        mappedTo: 'Połączone z',
        selectWFirmaAccount: 'Wybierz konto wFirma:',
        selectAccount: '-- Wybierz konto --',
        noMatchingCurrency: 'Brak kont wFirma z walutą',
        map: 'Połącz',
        mapError: 'Błąd łączenia kont',
        unmap: 'Usuń połączenie',
        unmapConfirm: 'Czy na pewno chcesz usunąć połączenie?',
        unmapError: 'Błąd usuwania połączenia',
        linkWFirmaAccount: 'Połącz z kontem wFirma',
        selectWFirmaAccountForEdit: 'Wybierz konto wFirma do połączenia'
      }
    }
  },
  wfirma: {
    accounts: {
      title: 'Konta wFirma',
      description: 'Synchronizuj i połącz konta firmy z kontami w wFirma',
      sync: 'Synchronizuj konta',
      syncSuccess: 'Konta zostały pomyślnie zsynchronizowane',
      syncError: 'Błąd synchronizacji kont',
      autoMap: 'Automatycznie połącz',
      autoMapSuccess: 'Automatycznie połączono kont',
      autoMapError: 'Błąd automatycznego łączenia kont',
      wfirmaAccounts: 'Konta w wFirma',
      noWFirmaAccounts: 'Brak zsynchronizowanych kont. Kliknij "Synchronizuj konta", aby załadować.',
      ourAccounts: 'Nasze konta',
      noOurAccounts: 'Brak kont firmy',
      mappedTo: 'Połączone z',
      selectWFirmaAccount: 'Wybierz konto wFirma:',
      selectLocalAccount: 'Wybierz lokalne konto:',
      selectAccount: '-- Wybierz konto --',
      noMatchingCurrency: 'Brak kont wFirma z walutą',
      map: 'Połącz',
      mapError: 'Błąd łączenia kont',
      unmap: 'Usuń połączenie',
      unmapConfirm: 'Czy na pewno chcesz usunąć połączenie?',
      unmapError: 'Błąd usuwania połączenia',
      linkWFirmaAccount: 'Połącz z kontem wFirma',
      selectWFirmaAccountForEdit: 'Wybierz konto wFirma do połączenia',
      syncStatus: 'Status wFirma',
      synchronized: 'Zsynchronizowane',
      notSynchronized: 'Nie',
      clearLocal: 'Usuń lokalne konta wFirma',
      clearLocalHint:
        'Po zmianie integracji wFirma wyczyść lokalny cache, potem zsynchronizuj i ponownie połącz konta. W wFirma nic nie jest usuwane.',
      clearLocalConfirm:
        'Usunąć wszystkie lokalnie zapisane konta wFirma i powiązania z kontami bankowymi? W wFirma nic nie jest usuwane. Potem kliknij „Synchronizuj konta”.',
      clearLocalSuccess: 'Usunięto wpisów',
      clearLocalError: 'Błąd usuwania lokalnych kont wFirma'
    }
  }
};
